<template>
  <div class="examination" id="examinationId">
    <div
      class="header"
      v-loading="loading2"
      element-loading-text="拼命加载中"
      element-loading-background="rgba(255, 255, 255, 0.8)"
    >
      <!-- <div class="title">初级会计职称 > 初级会计实务 > 2019年初级会计职称考试《初级会计实务》考试真题及解析</div> -->
      <!-- <div class="text">{{examName}}</div> -->
    </div>
    <div class="examMode">
      <div class="left" id="left">
        <div class="examination-none" v-if="questionList.length == 0">暂无错题解析</div>
        <div v-for="(item, index) in questionList" :key="index" :id="`inx${index}`">
          <div
            class="title"
            :style="`${fontSize.size2}`"
            v-if="
              item.questionTypeName == '单选题' &&
              (index == 0 ? true : questionList[index - 1].questionTypeName != '单选题')
            "
          >
            一、单项选择题
          </div>
          <div
            :style="`${fontSize.size2}`"
            v-if="
              item.questionTypeName == '不定项选择题' &&
              (index == 0
                ? true
                : questionList[index - 1].questionTypeName != '不定项选择题')
            "
            class="title"
          >
            二、不定项选择题
          </div>

          <div
            :style="`${fontSize.size2}`"
            v-if="
              item.questionTypeName == '判断题' &&
              (index == 0 ? true : questionList[index - 1].questionTypeName != '判断题')
            "
            class="title"
          >
            三、判断题
          </div>
          <div
            :style="`${fontSize.size2}`"
            v-if="
              item.questionTypeName == '多选题' &&
              (index == 0 ? true : questionList[index - 1].questionTypeName != '多选题')
            "
            class="title"
          >
            四、多选题
          </div>
          <div class="questionList">
            <div class="question">
              <div class="question-one">
                <div class="question-name">
                  <span class="name" :style="`${fontSize.size2}`"
                    >{{ index + 1 }} [{{ item.questionTypeName }}]</span
                  >
                  <span v-html="item.ptitle" :style="`${fontSize.size2}`"></span>
                  <div
                    v-if="item.questionTypeName == '不定项选择题'"
                    v-html="item.title"
                    :style="`${fontSize.size2}`"
                  ></div>
                  <span v-else v-html="item.title" :style="`${fontSize.size2}`"></span>
                </div>
                <div v-if="showResult">
                  <div
                    class="question-answer"
                    @click="nowIndex = index"
                    v-if="item.mode == '多选'"
                  >
                    <el-checkbox-group
                      v-if="item.optionList"
                      @change="selectItemss"
                      v-model="item.userAnswer"
                    >
                      <el-checkbox
                        v-for="(items, indexs) in item.optionList"
                        :key="indexs"
                        :label="items.options"
                      >
                        <span
                          :style="`${fontSize.size2}`"
                          style="color: rgb(162, 170, 188)"
                          >{{ items.options }}.</span
                        >
                        <span
                          :style="`${fontSize.size2}`"
                          v-html="items.name"
                          style="color: rgb(162, 170, 188)"
                          >{{ items.options }}.</span
                        >
                        <span
                          style="white-space: normal; line-height: 20px !important"
                        ></span>
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div
                    class="question-answer"
                    v-if="item.mode == '判断'"
                    @click="selectItems(index)"
                  >
                    <el-radio-group v-model="item.userAnswer">
                      <el-radio
                        label="对"
                        @click.native.prevent="checkSelect('对', index)"
                      >
                        <span :style="`${fontSize.size2}`">对</span>
                      </el-radio>
                      <el-radio
                        label="错"
                        @click.native.prevent="checkSelect('错', index)"
                      >
                        <span :style="`${fontSize.size2}`">错</span>
                      </el-radio>
                    </el-radio-group>
                  </div>
                  <div
                    class="question-answer"
                    @click="selectItems(index)"
                    v-if="item.mode == '单选'"
                  >
                    <el-radio-group v-model="item.userAnswer">
                      <el-radio
                        v-for="(items, indexs) in item.optionList"
                        :key="indexs"
                        :label="items.options"
                        @click.native.prevent="checkSelect(items.options, index)"
                      >
                        <span
                          :style="`${fontSize.size2}`"
                          style="color: rgb(162, 170, 188)"
                          >{{ items.options }}.</span
                        >
                        <span
                          :style="`${fontSize.size2}`"
                          v-html="items.name"
                          style="white-space: normal; line-height: 20px !important"
                        ></span>
                      </el-radio>
                    </el-radio-group>
                  </div>
                  <div class="question-answer" v-if="item.mode == '填写'">
                    <ue :id="'id' + index" :ids="index" @setName="setNameText"></ue>
                  </div>
                </div>
                <div v-else>
                  <div class="question-answer-result" v-if="item.mode == '多选'">
                    <div v-for="(items, indexs) in item.optionList" :key="indexs">
                      <div style="margin-left: 30px; margin-top: 10px">
                        <i
                          v-if="isInArray(items.options, item.answer)"
                          style="font-size: 18px; color: rgba(65, 212, 151, 1)"
                          class="iconfont icon-xuanze-fangkuang-tianchong"
                        ></i>
                        <i
                          v-else-if="isInArray(items.options, item.userAnswers)"
                          style="font-size: 18px; color: #fc5e5e"
                          class="iconfont icon-cuowu-fangkuang-tianchong"
                        ></i>
                        <i
                          v-else
                          style="font-size: 18px; color: #a2aabc"
                          class="iconfont icon-fangkuang"
                        ></i>
                        <span
                          :style="`${fontSize.size2}`"
                          style="color: rgb(162, 170, 188)"
                          >{{ items.options }}.</span
                        >
                        <span
                          :style="`${fontSize.size2}`"
                          v-html="items.name"
                          style="white-space: normal; line-height: 40px !important"
                        ></span>
                        <!-- <span
                          :style="`${fontSize.size2}`"
                          style="white-space: normal;line-height: 40px !important;"
                        >{{items.name}}</span>-->
                      </div>
                    </div>
                  </div>

                  <div class="question-answer-result" v-if="item.mode == '单选'">
                    <div v-for="(items, indexs) in item.optionList" :key="indexs">
                      <div style="margin-left: 30px; margin-top: 10px">
                        <i
                          v-if="item.answer == items.options"
                          style="font-size: 18px; color: rgba(65, 212, 151, 1)"
                          class="iconfont icon-zhengque1"
                        ></i>
                        <i
                          v-else-if="
                            item.userAnswer == items.options &&
                            item.answer != items.options
                          "
                          style="font-size: 18px; color: #fc5e5e"
                          class="iconfont icon-cuowu"
                        ></i>
                        <i
                          v-else
                          style="font-size: 18px; color: #a2aabc"
                          class="iconfont icon-quan"
                        ></i>
                        <span
                          :style="`${fontSize.size2}`"
                          style="color: rgb(162, 170, 188)"
                          >{{ items.options }}.</span
                        >
                        <span
                          :style="`${fontSize.size2}`"
                          v-html="items.name"
                          style="white-space: normal; line-height: 40px !important"
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div class="question-answer-result" v-if="item.mode == '判断'">
                    <div style="margin-left: 30px; margin-top: 10px">
                      <i
                        v-if="item.answer == '对'"
                        style="font-size: 21px; color: rgba(65, 212, 151, 1)"
                        class="iconfont icon-zhengque1"
                      ></i>
                      <i
                        v-else-if="item.userAnswer == '对' && item.answer == '错'"
                        style="font-size: 21px; color: #fc5e5e"
                        class="iconfont icon-cuowu"
                      ></i>
                      <i
                        v-else
                        style="font-size: 21px; color: #a2aabc"
                        class="iconfont icon-quan"
                      ></i>

                      <span
                        :style="`${fontSize.size2}`"
                        style="white-space: normal; line-height: 40px !important"
                        >对</span
                      >
                    </div>
                    <div style="margin-left: 30px; margin-top: 10px">
                      <i
                        v-if="item.answer == '错'"
                        style="font-size: 21px; color: rgba(65, 212, 151, 1)"
                        class="iconfont icon-zhengque1"
                      ></i>
                      <i
                        v-else-if="item.userAnswer == '错' && item.answer == '对'"
                        style="font-size: 21px; color: #fc5e5e"
                        class="iconfont icon-cuowu"
                      ></i>
                      <i
                        v-else
                        style="font-size: 21px; color: #a2aabc"
                        class="iconfont icon-quan"
                      ></i>
                      <span
                        :style="`${fontSize.size2}`"
                        style="white-space: normal; line-height: 40px !important"
                        >错</span
                      >
                    </div>
                  </div>
                  <div class="question-answer" v-if="item.mode == '填写'">
                    <ue :id="'id' + index" :ids="index" :value="item.userAnswer"></ue>
                  </div>
                </div>
                <!-- :class="isInArray(items,correctNumberList)?'select-item ge':isInArray(items,norNumberList)?'select-item':'select-item  re'" -->
                <div
                  v-show="!showResult"
                  :class="item.stys == 1 ? 'wrong-true' : 'wrong-false'"
                >
                  <i
                    :style="`${fontSize.size3}`"
                    :class="
                      item.stys == 1 ? 'iconfont icon-queding' : 'iconfont icon-guanbi'
                    "
                  ></i>
                  <span v-if="item.stys == 1"
                    >回答正确<span style="margin-left: 10px"
                      >{{ item.questionUserScore }}分</span
                    ></span
                  >
                  <span v-else
                    >回答错误<span style="margin-left: 10px"
                      >{{ item.questionUserScore }}分</span
                    ></span
                  >
                </div>
                <div
                  class="tabs"
                  :class="!showResult ? 'backs' : ''"
                  :style="`${fontSize.size3}`"
                >
                  <div class="tab-left">
                    <div
                      :style="`${fontSize.size2}`"
                      class="answer-true"
                      v-show="!showResult || item.showAnalysis"
                    >
                      正确答案：
                      <span
                        :style="`${fontSize.size2}`"
                        style="color: #41d497"
                        v-if="item.mode == '多选'"
                        >{{ item.answers }}</span
                      >
                      <span :style="`${fontSize.size2}`" style="color: #41d497" v-else>{{
                        item.answer
                      }}</span>
                    </div>
                    <div
                      :style="`${fontSize.size2}`"
                      class="answer-wrong mathDiv"
                      v-show="!showResult || item.showAnalysis"
                    >
                      我的答案：
                      <span
                        :style="`${fontSize.size2}`"
                        style="color: #41d497"
                        v-if="item.stys == 1"
                        v-html="item.userAnswer"
                      ></span>
                      <span
                        v-else
                        :style="
                          item.stys == 2
                            ? 'color:rgb(252, 94, 94)'
                            : 'color:#a2aabc' + `${fontSize.size2}`
                        "
                        ><span v-html="item.userAnswer"></span
                      ></span>
                    </div>
                  </div>
                  <div class="tab-right">
                    <!-- <div
                      class="tab-right-item"
                      v-if="!item.collect"
                      @click="collectQuestion(item,index)"
                    >
                      <i :style="`${fontSize.size2}`" class="iconfont icon-shoucang"></i>
                      <span :style="`${fontSize.size2}`">收藏本题</span>
                    </div>
                    <div class="tab-right-item" v-else @click="collectQuestion(item,index)">
                      <i
                        :style="`${fontSize.size2}`"
                        class="iconfont icon-shoucang1"
                        style="color:#c7000a;"
                      ></i>
                      <span :style="`${fontSize.size2}`" style="color:#c7000a;">取消收藏</span>
                    </div>-->
                    <div
                      class="tab-right-item"
                      v-if="!showResult"
                      @click="
                        errorRecoveryVisible = true;
                        questionId = item.id;
                      "
                    >
                      <i :style="`${fontSize.size2}`" class="iconfont icon-jiucuo"></i>
                      <span :style="`${fontSize.size2}`">纠错</span>
                    </div>
                    <div
                      v-if="!item.showAnalysis && !showResult"
                      @click="showAnalysisEvent(true, index)"
                      class="tab-right-item"
                    >
                      <i
                        :style="`${fontSize.size2}`"
                        class="iconfont icon-jiantou-xia"
                      ></i>
                      <span :style="`${fontSize.size2}`">展开解析</span>
                    </div>
                    <div
                      v-if="item.showAnalysis && !showResult"
                      @click="showAnalysisEvent(false, index)"
                      class="tab-right-item"
                    >
                      <i
                        :style="`${fontSize.size2}`"
                        class="iconfont icon-jiantou-shang1"
                      ></i>
                      <span :style="`${fontSize.size2}`">收起解析</span>
                    </div>
                  </div>
                </div>
                <div class="last" v-if="item.showAnalysis">
                  <!-- <div class="last-item" :style="`${fontSize.size3}`">
                    <span
                      :style="`${fontSize.size2}`"
                      style="color:rgb(162, 170, 188);white-space: nowrap !important;"
                    >知识点：</span>
                    <span :style="`${fontSize.size2}`">第1章 > 第1节</span>
                  </div>-->
                  <div class="last-item" :style="`${fontSize.size3}`">
                    <span
                      :style="`${fontSize.size2}`"
                      style="color: rgb(162, 170, 188); white-space: nowrap !important"
                      >教材页码：</span
                    >
                    <span :style="`${fontSize.size2}`">{{
                      item.page ? item.page : "无"
                    }}</span>
                  </div>
                  <div class="last-item" :style="`${fontSize.size3}`">
                    <span
                      :style="`${fontSize.size2}`"
                      style="color: rgb(162, 170, 188); white-space: nowrap !important"
                      >试卷难度：</span
                    >
                    <span :style="`${fontSize.size2}`">
                      <el-rate
                        disabled
                        :colors="rateColors"
                        v-model="item.hard"
                      ></el-rate>
                    </span>
                  </div>
                  <div class="last-item" :style="`${fontSize.size3}`">
                    <span
                      :style="`${fontSize.size2}`"
                      style="color: rgb(162, 170, 188); white-space: nowrap !important"
                    >
                      参考解析 ：
                    </span>
                    <span v-html="item.analysis"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right" id="right">
        <div id="fiexdtop">
          <div class="right-tabs">
            <div class="right-tabs-item" @click="leaveVisible = true">
              <i class="iconfont icon-fanhui1" :style="`${fontSize.size6}`"></i>
              <div>返回</div>
            </div>
            <div class="right-tabs-item" @click="counterDialogVisible = true">
              <i class="iconfont icon-37" :style="`${fontSize.size6}`"></i>
              <div>计算器</div>
            </div>

            <el-dropdown trigger="click" :hide-on-click="false">
              <span class="el-dropdown-link">
                <div class="right-tabs-item">
                  <i class="iconfont icon-shezhi" :style="`${fontSize.size6}`"></i>
                  <div>设置</div>
                </div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="dropdown-height">
                  <div class="text-size">
                    <div class="texts">字体大小</div>
                    <div>
                      <el-button-group>
                        <el-button
                          @click="changeSize(-2)"
                          :class="fontSize.style == 'small' ? 'res' : ''"
                          >小</el-button
                        >
                        <el-button
                          @click="changeSize(0)"
                          :class="fontSize.style == 'normal' ? 'res' : ''"
                          >正常</el-button
                        >
                        <el-button
                          @click="changeSize(2)"
                          :class="fontSize.style == 'big' ? 'res' : ''"
                          >大</el-button
                        >
                      </el-button-group>
                    </div>
                  </div>
                </el-dropdown-item>
                <!-- <el-dropdown-item class="dropdown-height">
                  <div class="text-size">
                    <div class="texts">自动下一题</div>
                    <div>
                      <el-switch
                        v-model="switchvalue"
                        active-color="#c7000a"
                        inactive-color="rgb(160,170,188)"
                      ></el-switch>
                    </div>
                  </div>
                </el-dropdown-item>-->
                <!-- <el-dropdown-item class="dropdown-height">
                  <div class="text-size">
                    <div class="texts">自动显示答案</div>
                    <div>
                      <el-switch
                        @change="autoQuestion"
                        v-model="switchvalue"
                        active-color="#c7000a"
                        inactive-color="rgb(160,170,188)"
                      ></el-switch>
                    </div>
                  </div>
                </el-dropdown-item>-->
                <!-- <el-dropdown-item class="dropdown-height">
                  <div class="text-size">
                    <div class="texts">背景模式</div>
                    <div>
                      <el-switch
                        v-model="switchvalue"
                        active-color="#c7000a"
                        inactive-color="rgb(160,170,188)"
                      ></el-switch>
                    </div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item class="dropdown-height">
                  <div class="text-size">
                    <div class="texts">背景颜色</div>
                    <div style="  display: flex;flex-direction: row;align-items: center;">
                      <el-color-picker
                        v-model="color"
                        show-alpha
                        :predefine="predefineColors"
                        @change="changeSubject"
                        @active-change="activeChangeSubject"
                      ></el-color-picker>
                    </div>
                  </div>
                </el-dropdown-item>-->
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="count-down">
            <div class="down-left">
              <i class="iconfont icon-shizhong" :style="`${fontSize.size3}`"></i>
              <span :style="`${fontSize.size3}`">
                {{ timer.hour > 9 ? timer.hour : "0" + timer.hour }}:
                {{ timer.minute > 9 ? timer.minute : "0" + timer.minute }}:
                {{ timer.second > 9 ? timer.second : "0" + timer.second }}
              </span>
            </div>
            <!-- <div class="down-right" @click="stopTimes">
              <i class="iconfont icon-zanting1" :style="`${fontSize.size2}`"></i>
              <span :style="`${fontSize.size2}`">暂停</span>
            </div>-->
          </div>
        </div>
        <div id="pdd">
          <div class="right-content">
            <div class="right-content-tilte">
              <div class="lefts" :style="`${fontSize.size2}`">
                <div>答题卡</div>
                <div class="reset">{{ doNumQuestions }}/{{ questionList.length }}</div>
              </div>
              <div class="rights">
                <i
                  class="iconfont iconzhankai"
                  v-if="!showRightList"
                  @click="showRightList = true"
                ></i>
                <i
                  class="iconfont iconshouqi"
                  v-if="showRightList"
                  @click="showRightList = false"
                ></i>
              </div>
            </div>
            <div v-if="showRightList">
              <div v-if="showResult" id="rightss" class="right-contents">
                <div
                  class="right-content-mian"
                  v-for="(item, index) in cardList"
                  :key="index"
                >
                  <div class="mian-title" :style="`${fontSize.size2}`">
                    {{ item.typeName }}
                    <span :style="`${fontSize.size1}`"
                      >（每题{{ item.questionTypeScore }}分，共{{
                        item.numberList.length
                      }}题）</span
                    >
                    <!-- <span
                      v-if="item.typeName=='单选题'"
                      :style="`${fontSize.size1}`"
                    >（每题{{item.questionTypeScore}}分，共{{item.numberList.length}}题）</span>
                    <span
                      v-if="item.typeName=='多选题'"
                      :style="`${fontSize.size1}`"
                    >（每题2分，共{{item.numberList.length}}题）</span>
                    <span
                      v-if="item.typeName=='判断题'"
                      :style="`${fontSize.size1}`"
                    >（每题2分，共{{item.numberList.length}}题）</span>
                    <span
                      v-if="item.typeName=='不定项选择题'"
                      :style="`${fontSize.size1}`"
                    >（每题2分，共{{item.numberList.length}}题）</span> -->
                  </div>

                  <div class="select">
                    <div v-for="(items, indexs) in item.numberList" :key="indexs">
                      <a :href="`#inx${items - 1}`" style="text-decoration: none">
                        <div
                          style="font-size: 13px"
                          :class="
                            questionList[items - 1].doNumTrue
                              ? 'select-item none'
                              : 'select-item'
                          "
                        >
                          {{ items }}
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="wrongOnly" class="right-contents">
                <div
                  class="right-content-mian"
                  v-for="(item, index) in cardList"
                  :key="index"
                >
                  <div class="mian-title" :style="`${fontSize.size2}`">
                    {{ item.typeName }}
                    <span :style="`${fontSize.size1}`"
                      >（每题{{ item.questionTypeScore }}分，共{{
                        item.numberList.length
                      }}题）</span
                    >
                    <!-- <span
                      v-if="item.typeName=='单选题'"
                      :style="`${fontSize.size1}`"
                    >（每题1.5分，共{{item.numberList.length}}题）</span>
                    <span
                      v-if="item.typeName=='多选题'"
                      :style="`${fontSize.size1}`"
                    >（每题2分，共{{item.numberList.length}}题）</span>
                    <span
                      v-if="item.typeName=='判断题'"
                      :style="`${fontSize.size1}`"
                    >（每题2分，共{{item.numberList.length}}题）</span>
                    <span
                      v-if="item.typeName=='不定项选择题'"
                      :style="`${fontSize.size1}`"
                    >（每题2分，共{{item.numberList.length}}题）</span> -->
                  </div>
                  <div class="select">
                    <div v-for="(items, indexs) in item.numberList" :key="indexs">
                      <a :href="`#inx${items - 1}`" style="text-decoration: none">
                        <div class="select-item re" style="font-size: 13px">
                          {{ items }}
                        </div>
                      </a>
                    </div>
                  </div>
                  <!-- <div class="select">
                  <div
                    class="select-item re"
                    v-for="(items,indexs) in item.numberList"
                    :key="indexs"
                    @click="goIndex(items)"
                  >{{items}}</div>
                  </div>-->
                </div>
              </div>
              <div v-else class="right-contents">
                <div
                  class="right-content-mian"
                  v-for="(item, index) in cardList"
                  :key="index"
                >
                  <div class="mian-title" :style="`${fontSize.size2}`">
                    {{ item.typeName }}

                    <span :style="`${fontSize.size1}`"
                      >（每题{{ item.questionTypeScore }}分，共{{
                        item.numberList.length
                      }}题）</span
                    >
                    <!-- <span
                      v-if="item.typeName=='单选题'"
                      :style="`${fontSize.size1}`"
                    >（每题1.5分，共{{item.numberList.length}}题）</span>
                    <span
                      v-if="item.typeName=='多选题'"
                      :style="`${fontSize.size1}`"
                    >（每题2分，共{{item.numberList.length}}题）</span>
                    <span
                      v-if="item.typeName=='判断题'"
                      :style="`${fontSize.size1}`"
                    >（每题2分，共{{item.numberList.length}}题）</span>
                    <span
                      v-if="item.typeName=='不定项选择题'"
                      :style="`${fontSize.size1}`"
                    >（每题2分，共{{item.numberList.length}}题）</span> -->
                  </div>
                  <div class="select">
                    <div v-for="(items, indexs) in item.numberList" :key="indexs">
                      <a :href="`#inx${items - 1}`" style="text-decoration: none">
                        <!-- :class="isInArray(items,correctNumberList)?'select-item ge':'select-item re'" -->
                        <div
                          style="font-size: 13px"
                          :class="
                            isInArray(items, correctNumberList)
                              ? 'select-item ge'
                              : isInArray(items, norNumberList)
                              ? 'select-item'
                              : 'select-item  re'
                          "
                        >
                          {{ items }}
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="!showResult"
                class="right-content-nums"
                :style="`${fontSize.size2}`"
              >
                <div class="itwms">
                  <div class="itwms-squ re"></div>
                  <div>错误&nbsp;{{ resultNums.no }}</div>
                </div>
                <div class="itwms">
                  <div class="itwms-squ ge"></div>
                  <div>正确&nbsp;{{ resultNums.yes }}</div>
                </div>
                <div class="itwms">
                  <div class="itwms-squ"></div>
                  <div>未做&nbsp;{{ questionList.length - doNumQuestions }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="fiexdbuttom" :class="showRightList ? 'buttom-fixed' : 'bottom-top'">
          <!-- <div
            v-if="showResult"
            :class="showRightList?'bottom-button':'bottom-button'"
            :style="`${fontSize.size2}`"
            @click="saveVisible=true"
          >保存进度，下次继续</div>
          <div style="height:10px;z-index:100;background:#FFF"></div>-->
          <!-- <div
            v-if="showResult"
            :class="showRightList?'bottom-button':'bottom-button'"
            :style="`${fontSize.size2}`"
            @click="submitVisible=true"
          >交卷</div>-->
        </div>
      </div>
      <el-dialog title="本题纠错" :visible.sync="errorRecoveryVisible" width="30%">
        <el-form
          style="padding: 0 20px"
          :model="errorRecoveryForm"
          :rules="errorRecoveryFormRules"
          ref="errorRecoveryForm"
          label-width="50px"
          class="demo-ruleForm"
        >
          <el-form-item label="纠错" prop="name">
            <el-select
              size="small"
              style="width: 100%"
              v-model="errorRecoveryForm.select"
              placeholder="请选择纠错"
              multiple
            >
              <el-option
                v-for="(item, index) in errorRecoveryOptions"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内容" prop="name">
            <el-input
              size="small"
              type="textarea"
              style="width: 100%"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入内容"
              v-model="errorRecoveryForm.textarea"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footers">
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="errorRecoveryVisible = false"
              >取 消</el-button
            >
            <el-button
              size="small"
              style="background: #c7000a; color: #fff; border-color: #c7000a"
              @click="addQuestionQuery"
              >确 定</el-button
            >
          </span>
        </div>
      </el-dialog>
      <el-dialog title="您正在结束作答" center :visible.sync="submitVisible" width="30%">
        <div :style="`${fontSize.size2};color: #455A64;padding:20px;`">
          {{
            questionList.length - doNumsDone
              ? "您还有" + (questionList.length - doNumsDone) + "道试题未作答，"
              : ""
          }}
          是否确定提交作答？
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="submitVisible = false">取 消</el-button>
          <el-button
            size="small"
            style="background: #c7000a; color: #fff; border-color: #c7000a"
            @click="submitExercise"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- <el-drawer title="计算器" :visible.sync="counterDialogVisible" direction="rtl">
        <counter></counter>
      </el-drawer>-->
      <!-- <el-dialog
        :close-on-click-modal="false"
        v-el-drag-dialog
        width="500px"
        :visible.sync="counterDialogVisible"
        title="计算器"
      >
        <counter></counter>
      </el-dialog>-->
      <el-dialog
        title="练习报告"
        :close-on-click-modal="false"
        :showClose="false"
        :visible.sync="reportVisible"
        width="80%"
      ></el-dialog>
      <el-dialog
        title="暂停"
        :close-on-click-modal="false"
        :visible.sync="timeVisible"
        width="30%"
      >
        <div style="padding: 10px 20px">暂停已暂停。</div>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="
              setTimes();
              timeVisible = false;
            "
            style="background-color: #c7000a; border-color: #c7000a"
            >继续做题</el-button
          >
        </span>
      </el-dialog>
      <el-dialog title="您正在保存作答" center :visible.sync="saveVisible" width="30%">
        <div :style="`${fontSize.size2};color: #455A64;padding:20px;`">
          您还有{{ questionList.length - doNumQuestions }}道试题未作答，是否确定保存？
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="saveVisible = false">取 消</el-button>
          <el-button
            size="small"
            style="background: #c7000a; color: #fff; border-color: #c7000a"
            @click="saveExercise"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog title="您正在查看考试解析" :visible.sync="leaveVisible" width="30%">
        <div :style="`${fontSize.size2};color: #455A64;padding:20px;`">
          是否确定返回？
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="leaveVisible = false">取 消</el-button>
          <el-button
            size="small"
            style="background: #c7000a; color: #fff; border-color: #c7000a"
            @click="goBack"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <drag @closeDialog="closeDialogEvement()" v-if="counterDialogVisible"></drag>
    </div>
  </div>
</template>

<script>
import counter from "../common/inx";
import drag from "../common/drag";
import ue from "../common/UE";
import elDragDialog from "../directive/el-drag-dialog";

export default {
  directives: { elDragDialog },
  data() {
    return {
      examName: JSON.parse(localStorage.getItem("jump")).name,
      doNumsDone: 0,
      norNumberList: [],
      timer: {
        hour: 0,
        minute: 0,
        second: 60,
      },
      doNums: 0,
      correctNumberList: [],
      resultMessage: {},

      saveVisible: false,
      showRightList: true,
      leaveVisible: false,
      submitVisible: false,
      timeVisible: false,
      reportVisible: false,
      errorRecoveryForm: {
        select: [],
        textarea: "",
      },
      questionId: "",
      errorRecoveryFormRules: {
        select: [{ required: true, message: "请输入纠错", trigger: "blur" }],
      },
      doNumQuestions: 0,
      predefineColors: [
        "#ff4500",
        "#ff8c00",
        "#ffd700",
        "#90ee90",
        "#00ced1",
        "#1e90ff",
        "#c71585",
        "rgba(255, 69, 0, 0.68)",
        "rgb(255, 120, 0)",
        "hsv(51, 100, 98)",
        "hsva(120, 40, 94, 0.5)",
        "hsl(181, 100%, 37%)",
        "hsla(209, 100%, 56%, 0.73)",
        "#c7158577",
      ],
      counterDialogVisible: false,
      switchvalue: false,

      errorRecoveryOptions: [
        { name: "答案有问题\r\n" },
        { name: "答案与解析不相符\r\n" },
        { name: "有错别字\r\n" },
        { name: "选项有问题\r\n" },
        { name: "其他\r\n" },
      ],
      cardList: [],
      questionList: [],
      resultNums: {
        yes: 0,
        no: 0,
      },
      analysis: 0,
      nowIndex: 0,
      timeData: [],
      percentList: [],
      timerModel: "",
      showSumbit: false,
      wrongOnly: false,
      loading2: false,
      showResult: true,
      errorRecoveryVisible: false,
      radio: 3,
      rateColors: ["#c7000a", "#c7000a", "#c7000a"],
      value1: 3,
      color: "#c7000a",
    };
  },
  components: { counter, ue, drag },

  watch: {
    nowIndex(val, oldVal) {},
    submitVisible(val, oldVal) {
      if (val) {
        this.doNumsDone = 0;
        this.questionList.forEach((item) => {
          if (item.mode == "多选") {
            if (item.userAnswer.length > 0) {
              this.doNumsDone++;
            }
          } else {
            if (item.userAnswer) {
              this.doNumsDone++;
            }
          }
        });
      }
    },
  },
  created() {},
  mounted() {
    if (JSON.parse(localStorage.getItem("jump")).type == "exam") {
      this.getQuestionByChapter();
    } else {
      this.correctNumberList = JSON.parse(
        localStorage.getItem("examAchievement")
      ).correctNumberList;
      this.getQuestionByExercise(
        JSON.parse(localStorage.getItem("jump")).exerciseId,
        JSON.parse(localStorage.getItem("jump")).sty
      );
    }

    // if (this.$route.query.dotime) {
    //   this.timer.hour = Math.floor(this.$route.query.dotime / 60) || 0;
    //   if (this.$route.query.dotime % 60 == 0) {
    //     this.timer.hour = this.timer.hour - 1;
    //     this.timer.minute = 59;
    //   } else {
    //     this.timer.minute = (this.$route.query.dotime % 60) - 1;
    //   }
    //   this.timer.second = 60;
    // }
    // if (this.$route.query.show) {
    //   this.getExerciseResultById();
    // } else {
    //   this.getQuestionByChapter();
    // }
    // window.addEventListener("scroll", this.handleScroll, true);
  },
  computed: {
    fontSize() {
      return this.$store.state.fontSize;
    },
  },
  methods: {
    closeDialogEvement() {
      this.counterDialogVisible = false;
    },
    selectItemss(val) {
      let count = 0;
      this.questionList.forEach((item, index) => {
        if (item.mode == "多选") {
          if (item.userAnswer.length > 0) {
            this.$set(this.questionList[index], "doNumTrue", true);
            count++;
          } else {
            this.$set(this.questionList[index], "doNumTrue", false);
          }
        } else {
          if (item.userAnswer) {
            this.$set(this.questionList[index], "doNumTrue", true);
            count++;
          } else {
            this.$set(this.questionList[index], "doNumTrue", false);
          }
        }
      });
      this.doNumQuestions = count;
      // if (val.length > 0) {
      //   if (this.questionList[this.nowIndex].userAnswer.length > 0) {
      //     console.log(1111, val, this.nowIndex);
      //     this.$set(this.questionList[this.nowIndex], "doNumTrue", true);
      //     this.doNumQuestions++;
      //   }
      // } else {
      //   console.log(1111, val, this.nowIndex);
      //   this.$set(this.questionList[this.nowIndex], "doNumTrue", false);
      //   this.doNumQuestions--;
      // }
    },
    selectItems(index) {
      let count = 0;
      this.questionList.forEach((item, index) => {
        if (item.mode == "多选") {
          if (item.userAnswer.length > 0) {
            this.$set(this.questionList[index], "doNumTrue", true);
            count++;
          } else {
            this.$set(this.questionList[index], "doNumTrue", false);
          }
        } else {
          if (item.userAnswer) {
            this.$set(this.questionList[index], "doNumTrue", true);
            count++;
          } else {
            this.$set(this.questionList[index], "doNumTrue", false);
          }
        }
      });
      this.doNumQuestions = count;
      // if (this.questionList[index].mode == "多选") {
      //   if (this.questionList[index].userAnswer.length > 0) {
      //     this.$set(this.questionList[index], "doNumTrue", true);
      //     this.doNumQuestions++;
      //   } else {
      //     this.$set(this.questionList[index], "doNumTrue", false);
      //     this.doNumQuestions--;
      //   }
      // } else {
      //   if (this.questionList[index].userAnswer) {
      //     this.$set(this.questionList[index], "doNumTrue", true);
      //     this.doNumQuestions++;
      //   } else {
      //     this.$set(this.questionList[index], "doNumTrue", false);
      //     this.doNumQuestions--;
      //   }
      // }
      setTimeout(() => {
        if (this.switchvalue) {
          this.questionList[index].showAnalysis = true;
        }
      }, 1000);
    },
    autoQuestion(val) {
      // this.showAnalysisAuto();
      // if (val) {
      //   this.$nextTick(function() {
      //     this.questionList.forEach((item, index) => {
      //       this.$set(this.questionList[index], "showAnalysis", true);
      //     });
      //   });
      // } else {
      //   this.$nextTick(function() {
      //     this.questionList.forEach((item, index) => {
      //       this.$set(this.questionList[index], "showAnalysis", false);
      //     });
      //   });
      // }
    },
    // showAnalysisAuto() {
    //   setTimeout(() => {
    //     if (this.switchvalue && this.showResult) {
    //       if (this.questionList[this.nowIndex - 1].mode == "多选") {
    //         if (this.questionList[this.nowIndex - 1].userAnswer.length > 0) {
    //           this.$set(
    //             this.questionList[this.nowIndex - 1],
    //             "showAnalysis",
    //             true
    //           );
    //         }
    //       } else {
    //         if (this.questionList[this.nowIndex - 1].userAnswer) {
    //           this.$set(
    //             this.questionList[this.nowIndex - 1],
    //             "showAnalysis",
    //             true
    //           );
    //         }
    //       }
    //       this.showAnalysisAuto();
    //     }
    //   }, 1000);
    // },
    timerEvent() {
      if (this.timer.second == 0 && this.timer.minute == 0 && this.timer.hour == 0) {
        clearInterval(this.timerModel);
        this.submitExercise();
      } else {
        if (this.timer.second == 0) {
          if (this.timer.minute == 0) {
            if (this.timer.hour > 0) {
              this.timer.minute = 60;
              this.timer.hour = this.timer.hour - 1;
            }
          }
          if (this.timer.minute > 0) {
            this.timer.second = 60;
            this.timer.minute = this.timer.minute - 1;
          }
        }
        this.timer.second--;
      }
    },
    setTimes() {
      this.timerModel = setInterval(this.timerEvent, 1000);
    },
    stopTimes() {
      if (this.showResult) {
        this.timeVisible = true;
        clearInterval(this.timerModel);
      } else {
        this.$message.warning("您已交卷");
      }
    },
    getQuestionByChapter() {
      this.loading2 = true;
      // var apiName = "";
      // if (this.$route.query.type == "chapter") {
      //   apiName = "getQuestionByChapter";
      //   this.params.chapterId = this.$route.query.id;
      // } else if (this.$route.query.type == "exam") {
      //   apiName = "getQuestionByExam";
      //   this.params.examId = this.$route.query.id;
      // } else if (this.$route.query.type == "knowledge") {
      //   apiName = "getQuestionByKnowledge";
      //   this.params.knowledgeId = this.$route.query.id;
      // }
      // this.params.exerciseType = this.$route.query.type;
      this.api.question
        .getQuestionByExam({
          type: "exam",
          examId: JSON.parse(localStorage.getItem("jump")).id,
        })
        .then((res) => {
          this.loading2 = false;
          if (res.code == 0) {
            if (res.data.length > 0) {
              this.setTimes();
              let chapterLog = null;
              if (
                JSON.parse(
                  localStorage.getItem(
                    JSON.parse(localStorage.getItem("jump")).type +
                      "_" +
                      JSON.parse(localStorage.getItem("jump")).id
                  )
                ) != null
              ) {
                this.timer = JSON.parse(
                  localStorage.getItem(
                    JSON.parse(localStorage.getItem("jump")).type +
                      "_" +
                      JSON.parse(localStorage.getItem("jump")).id
                  )
                ).timer;
                chapterLog = JSON.parse(
                  localStorage.getItem(
                    JSON.parse(localStorage.getItem("jump")).type +
                      "_" +
                      JSON.parse(localStorage.getItem("jump")).id
                  )
                ).questionList;
              }
              this.cardList = res.cardList;
              res.data.forEach((element, iss) => {
                if (element.answer == "A,B,C,D") {
                  console.log("11212121     ", iss);
                }

                element.doNumTrue = false;
                element.showAnalysis = false;
                if (element.mode == "多选") {
                  element.answers = element.answer;
                  element.userAnswer = [];
                } else {
                  element.userAnswer = "";
                }
                if (chapterLog != null) {
                  for (let log of chapterLog) {
                    if (element.id == log.id) {
                      element.userAnswer = log.userAnswer;
                    }
                  }
                }
              });
              for (let log of res.data) {
                if (log.mode == "多选") {
                  if (log.userAnswer.length > 0) {
                    log.doNumTrue = true;
                    this.doNumQuestions++;
                  }
                } else {
                  if (log.userAnswer) {
                    log.doNumTrue = true;
                    this.doNumQuestions++;
                  }
                }
              }
              this.questionList = res.data;
            } else {
              this.$message.warning("当前练习题目为空");
              this.goBack();
            }
          } else {
            this.$message.error(res.msg);
          }
        });
    },

    activeChangeSubject(val) {
      this.color = val;
    },
    changeSubject(val) {
      this.color = val;
    },
    changeSize(sty) {
      if (sty < 0) {
        let fontSize = {
          size1: "font-size:8px",
          size2: "font-size:10px",
          size3: "font-size:12px",
          size6: "font-size:22px",
          style: "small",
        };
        this.$store.commit("ChangeFontSize", fontSize);
      } else if (sty == 0) {
        let fontSize = {
          size1: "font-size:12px",
          size2: "font-size:14px",
          size3: "font-size:16px",
          size6: "font-size:26px",
          style: "normal",
        };
        this.$store.commit("ChangeFontSize", fontSize);
      } else {
        let fontSize = {
          size1: "font-size:16px",
          size2: "font-size:18px",
          size3: "font-size:20px",
          size6: "font-size:30px",
          style: "big",
        };
        this.$store.commit("ChangeFontSize", fontSize);
      }
    },
    recreation() {
      this.$confirm("是否确认重新练习？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.cardList = [];
          this.correctNumberList = [];
          this.resultMessage = {};
          this.questionList = [];
          this.errorRecoveryForm = {
            select: [],
            textarea: "",
          };
          this.questionId = "";
          this.nowIndex = 1;
          this.showSumbit = false;
          this.showResult = true;
          this.wrongOnly = false;
          this.switchvalue = false;
          this.showRightList = true;
          this.radio = 3;
          this.resultNums = {
            yes: 0,
            no: 0,
          };
          this.getQuestionByChapter();
        })
        .catch(() => {});
    },
    setNameText(val) {
      if (val.index >= 0) {
        this.questionList[val.index].userAnswer = val.content;
      }
    },
    showAnalysisEvent(data1, data2) {
      this.$nextTick(function () {
        this.$set(this.questionList[data2], "showAnalysis", data1);
      });
    },
    showAnalysisEvents(data1, data2) {
      this.$nextTick(function () {
        this.$set(this.questionList[this.nowIndex - 1], "showAnalysis", true);
      });
    },
    addQuestionQuery() {
      var item = "";
      this.errorRecoveryForm.select.forEach((element) => {
        item += element;
      });
      if (this.errorRecoveryForm.textarea.length > 100) {
        this.$message.error("反馈内容超出字数限制");
        return;
      }
      // if (this.errorRecoveryForm.select == 0) {
      //   item += "答案有问题\r\n";
      // } else if (this.errorRecoveryForm.select == 1) {
      //   item += "答案与解析不相符\r\n";
      // } else if (this.errorRecoveryForm.select == 2) {
      //   item += "有错别字\r\n";
      // } else if (this.errorRecoveryForm.select == 3) {
      //   item += "选项有问题\r\n";
      // } else if (this.errorRecoveryForm.select == 4) {
      //   item += "其他\r\n";
      // }

      var content = item + this.errorRecoveryForm.textarea;
      this.api.question
        .addQuestionQuery({
          typeId: this.$route.query.id,
          type: this.$route.query.type,
          // typeId: "1199969808057110529",
          // type: "exam",
          questionId: this.questionId,
          query: content,
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("添加成功");
            this.errorRecoveryVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //查看错题
    getQuestionByExercise(exerciseId, sty) {
      this.norNumberList = [];
      this.loading2 = true;
      this.wrongOnly = sty;
      this.api.question
        .getQuestionByExercise({
          exerciseId: exerciseId,
          wrongOnly: sty,
        })
        .then((res) => {
          if (res.code == 0) {
            this.loading2 = false;
            let counts = 0;

            res.data.forEach((element, index) => {
              let indexs = index + 1;
              if (element.mode == "填写") {
                if (!element.userAnswer) {
                  element.userAnswer = "未作答";
                }
              }
              if (element.userAnswer) {
                counts++;
              }
              element.stys = 3;
              if (element.userAnswer) {
                console.log("indexs", indexs, this.correctNumberList);
                if (this.isInArray(indexs, this.correctNumberList)) {
                  this.resultNums.yes = this.resultNums.yes + 1;
                  element.stys = 1;
                } else {
                  this.resultNums.no = this.resultNums.no + 1;
                  console.log("111111");
                  element.stys = 2;
                }
              }
              element.showAnalysis = true;
              if (element.mode == "多选") {
                if (element.userAnswer.length == 0) {
                  this.norNumberList.push(index + 1);
                }
                element.answers = element.answer;
                // element.answer = element.answer.split(",");
                // element.userAnswers = element.userAnswer.split(",");
              } else {
                if (!element.userAnswer) {
                  this.norNumberList.push(index + 1);
                }
              }
            });

            this.cardList = res.cardList;
            this.doNumQuestions = counts;
            this.questionList = res.data;
            this.reportVisible = false;
            this.showResult = false;
            this.showSumbit = false;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //
    getExerciseResultById(exerciseId) {
      let apiName = "";
      let apiParam = {};
      if (this.$route.query.show && !exerciseId) {
        apiName = "getExerciseResultByType";
        apiParam = {
          type: this.$route.query.type,
          typeId: this.$route.query.id,
          // typeId: "1199969808057110529",
          // type: "exam"
        };
      } else {
        apiName = "getExerciseResultById";
        apiParam = {
          exerciseId: exerciseId,
        };
      }
      this.api.question[apiName](apiParam).then((res) => {
        if (res.code == 0) {
          this.getExerciseTrend15();
          let questionNums = 0;
          res.cardList.forEach((item, index) => {
            item.yes = 0;
            item.no = 0;

            item.numberList.forEach((items) => {
              questionNums++;
              if (this.isInArray(items, res.correctNumberList)) {
                item.yes++;
              } else {
                item.no++;
              }
            });
          });
          res.doNums = this.doNums;
          res.questionNums = this.questionNums;
          this.correctNumberList = res.correctNumberList;
          this.resultMessage = res;
          this.resultMessage.dotime = this.$route.query.dotime;
          this.reportVisible = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getExerciseTrend15() {
      let nowCourseId = JSON.parse(localStorage.getItem("nowCourse")).nowCourseId;
      this.api.question
        .getExerciseTrend15({
          courseId: nowCourseId,
          isExam: true,
        })
        .then((result) => {
          if (result.code == 0) {
            this.timeData = result.timeList;
            this.percentList = result.percentList;
          } else {
            this.$message.error(result.msg);
          }
        });
    },
    submitExercise() {
      this.doNums = 0;
      var date = new Date();
      let questionFormList = [];

      this.questionList.forEach((item) => {
        if (item.mode == "多选") {
          let userAnswer = "";
          if (item.userAnswer.length > 0) {
            this.doNums++;
            item.userAnswer.sort((a, b) => {
              return a.localeCompare(b);
            });
            item.userAnswer.forEach((itemss, inx) => {
              userAnswer =
                userAnswer + itemss + (item.userAnswer.length - 1 == inx ? "" : ",");
            });
          }
          item.userAnswer = userAnswer;
        } else {
          if (item.userAnswer) {
            this.doNums++;
          }
        }
        questionFormList.push({
          id: item.id,
          userAnswer: item.userAnswer,
        });
      });
      // this.timer.second = 0;

      let exerciseTime =
        this.$route.query.dotime - (this.timer.hour * 60 + this.timer.minute);
      this.api.question
        .submitExercise({
          // typeId: "1199969808057110529",
          // type: "exam",
          typeId: this.$route.query.id,
          type: this.$route.query.type,
          questionFormList: questionFormList,
          exerciseTime: exerciseTime,
        })
        .then((res) => {
          if (res.code == 0) {
            this.submitVisible = false;
            // this.$router.push({
            //   path:"/analysis",
            //   query:{
            //     exerciseId:res.exerciseId
            //   }
            // });
            this.getExerciseResultById(res.exerciseId);
            let time =
              this.$route.query.dotime - (this.timer.hour * 60 + this.timer.minute);
            console.log("this.timer.hour", this.timer.hour);
            console.log("this.timer.minute", this.timer.minute);
            console.log("time", time);
            this.timer.hour = Math.floor(time / 60);
            if (time % 60 == 0) {
              if (this.timer.hour > 0) {
                this.timer.hour = this.timer.hour - 1;
                this.timer.minute = 59;
              } else {
                this.timer.minute = 0;
              }
            } else {
              this.timer.minute = time % 60;
            }
            this.timer.minute--;
            this.timer.second = 60 - this.timer.second;
            clearInterval(this.timerModel);
            this.$message.success("提交成功");
            this.showResult = false;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    collectQuestion(item, index) {
      this.api.question
        .collectQuestion({
          typeId: this.$route.query.id,
          type: this.$route.query.type,

          questionId: item.id,
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.questionList[index].collect = !this.questionList[index].collect;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    checkSelect(e, index) {
      e === this.questionList[index].userAnswer
        ? (this.questionList[index].userAnswer = "")
        : (this.questionList[index].userAnswer = e);
    },
    goBack() {
      this.$router.go(-1);
      // this.$router.push({
      //   path: "/testInformation",
      //   query: {
      //     names: this.$route.query.names,
      //     id: this.$route.query.id,
      //     type: this.$route.query.type
      //   }
      // });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: this.resultMessage.cardList.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    changeSize(sty) {
      if (sty < 0) {
        let fontSize = {
          size1: "font-size:8px",
          size2: "font-size:9px",
          size3: "font-size:12px",
          size4: "font-size:10px",
          size6: "font-size:22px",
          style: "small",
        };
        this.$store.commit("ChangeFontSize", fontSize);
      } else if (sty == 0) {
        let fontSize = {
          size1: "font-size:12px",
          size2: "font-size:13px",
          size3: "font-size:16px",
          size4: "font-size:14px",
          size6: "font-size:26px",
          style: "normal",
        };
        this.$store.commit("ChangeFontSize", fontSize);
      } else {
        let fontSize = {
          size1: "font-size:16px",
          size2: "font-size:17px",
          size3: "font-size:20px",
          size4: "font-size:18px",
          size6: "font-size:30px",
          style: "big",
        };
        this.$store.commit("ChangeFontSize", fontSize);
      }
    },
    saveExercise() {
      var logs = [];
      let obj = {};
      obj.timer = this.timer;
      for (let item of this.questionList) {
        logs.push({
          id: item.id,
          userAnswer: item.userAnswer,
          seeAnalysis: item.seeAnalysis,
        });
      }
      obj.questionList = logs;

      localStorage.setItem(
        this.$route.query.type + "_" + this.$route.query.id,
        JSON.stringify(obj)
      );
      let day2 = new Date();
      day2.setTime(day2.getTime());
      let s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate();
      let objs = {};
      objs.id = this.$route.query.id;
      objs.obj = obj;
      objs.type = this.$route.query.type;
      objs.names = this.$route.query.names;
      objs.time = s2;
      localStorage.setItem("last", JSON.stringify(objs));
      this.saveVisible = false;
      this.$message.success("保存成功");
      this.goBack();
      // $api.setStorage(this.type + "_time_" + this.typeId, this.useTime);
    },
    activeChangeSubject(val) {
      this.color = val;
    },
    changeSubject(val) {
      this.color = val;
    },
  },
};
</script>
<style lang="less" rel="stylesheet/less">
@import "../../../static/css/main.less";
.examination {
  p {
    word-wrap: break-word;
    display: inline !important;
    /*或者是下面一种方法让单词强制换行*/
    // word-break: break-all;
  }
  img {
    width: 100%;
  }
  .el-dialog__header {
    text-align: left !important;
  }
  .wrong-true {
    width: 120px;
    border-radius: 8px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    color: #41d497;
    background-color: rgba(236, 251, 244, 1);
  }
  .wrong-false {
    width: 120px;
    border-radius: 8px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    color: #fc5e5e;
    background-color: rgba(255, 239, 239, 1);
  }
  .examMode {
    display: flex;
    .examination-none {
      position: absolute;
      left: 40%;
      height: 30%;
    }
    .left-fixed {
      position: fixed;
      top: 0px;
      // left: calc(5% + 20px);

      width: 70% !important;
      overflow-style: none;
    }
    // .right-fixed::-webkit-scrollbar {
    //   width: 6px;
    //   height: 0px;
    // }
    .right-fixed {
      position: fixed;
      top: 0px;
      // z-index: 10000;
      // overflow-y: true;
      height: @height !important;
      left: calc(50% + 296px);
      // right: calc(5% + 40px);
      // width: calc(22.5% - 30px) !important;
      width: 20%;
      overflow-style: none;
    }
    .right {
      // width: 25%;
      position: absolute;
      top: 110px;
      right: 50px;
      padding-right: 6px;
      width: 20%;
      .padding-content {
        // padding-bottom: 130px;
        padding-top: 130px;
        z-index: 0.1;
        // overflow-style: none;
      }
      .top-fixed {
        position: fixed;
        top: 0px;
        width: 280px !important;
        z-index: 1000;
      }
      .bottom-top {
        width: 280px !important;
      }
      .buttom-fixed {
        width: 280px !important;
        position: fixed;
        bottom: 0px;
        z-index: 1000;
      }
      // width: 25%;
      margin-left: 20px;

      .bottom-button {
        // margin: 0 10px;
        cursor: pointer;
        background: #c7000a;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        text-align: center;
        border-radius: 4px;
      }
      .bottom-button:first-child {
        margin-top: 20px;
      }
      .right-content {
        margin-top: 20px;
        background: #ffffff;
        .right-content-nums {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: 10px 0px;
          border-top: rgb(162, 170, 188) 1px dashed;
          color: rgb(69, 90, 100);
          padding: 10px 16px;
          .itwms {
            display: flex;
            flex-direction: row;
            align-items: center;
            .itwms-squ {
              width: 16px;
              height: 16px;
              border: rgb(162, 170, 188) 1px solid;
              border-radius: 4px;
              margin-right: 4px;
            }
            .re {
              background: rgb(252, 94, 94);
              border: rgb(252, 94, 94) 1px solid;
            }
            .ge {
              background: #41d497;
              border: #41d497 1px solid;
            }
          }
        }
        .right-contents::-webkit-scrollbar {
          display: none;
        }
        .right-contents {
          // height: calc(@height - 400px);
          overflow: scroll;
          height: 380px;
          .right-content-mian {
            padding: 10px;

            .select {
              margin-top: 10px;
              display: flex;
              flex-wrap: wrap;
              .select-item {
                cursor: pointer;

                width: 30px;
                height: 24px;
                color: rgb(69, 90, 100);
                line-height: 24px;
                text-align: center;
                border: rgb(162, 170, 188) 1px solid;
                border-radius: 4px;
                margin-right: 10px;
                margin-bottom: 10px;
                a {
                  color: rgb(69, 90, 100) !important;
                  border-bottom: 0px !important;
                  text-decoration: none !important;
                }
              }
              .none {
                background: rgb(162, 170, 188);
                border: rgb(162, 170, 188) 1px solid;

                color: #fff;
                &:hover {
                  opacity: 0.6;
                }
              }
              .re {
                background: rgb(252, 94, 94);
                border: rgb(252, 94, 94) 1px solid;

                color: #ffffff;
                a {
                  color: #ffffff !important;
                  text-decoration: none !important;
                  border-bottom: 0px !important;
                }
                &:hover {
                  opacity: 0.6;
                }
              }
              .ge {
                background: #41d497;
                border: #41d497 1px solid;

                color: #ffffff;
                &:hover {
                  opacity: 0.6;
                }
              }
            }
            .mian-title {
              line-height: 30px;
              color: rgb(69, 90, 100);
              span {
                color: #a2aabc;
              }
            }
          }
        }

        .right-content-tilte {
          border-bottom: rgba(238, 238, 238, 1) 1px solid;
          padding: 10px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .rights {
            cursor: pointer;
            i {
              &:hover {
                color: #c7000a;
              }
            }
          }
          .lefts {
            display: flex;
            flex-direction: row;
            align-items: center;

            .reset {
              cursor: pointer;
              color: #c7000a;
              margin-left: 10px;
            }
          }
        }
      }
      .count-down {
        display: flex;
        padding-top: 20px;
        padding: 20px;
        justify-content: space-between;
        align-items: center;
        background: #ffffff;

        border-top: rgba(238, 238, 238, 1) 1px solid !important;
        border-bottom: rgba(238, 238, 238, 1) 1px solid !important;

        .down-right {
          color: #999;
          cursor: pointer;
        }
        .down-left {
          i {
            color: #999;
            font-weight: bold;
          }
          span {
            color: #c7000a;
          }
        }
      }
      .right-tabs {
        padding: 10px 20px;
        background: #ffffff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .right-tabs-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          i {
            font-weight: bold;
            margin-bottom: 4px;
          }
          &:hover {
            color: #c7000a;
          }
        }
      }

      .right-name {
        font-size: 13px;
        color: #a2aabc;
        height: 15px;
      }
      .float-left {
        float: left;
      }
      .float-right {
        float: right;
      }
      .right-question {
        font-size: 13px;
        margin-top: 15px;
        margin-bottom: 20px;
      }
    }
    .counter {
      position: fixed;
      bottom: 0px;
      right: 0px;
      width: 460px;
      z-index: 10;
    }
    .questionList {
      margin-bottom: 20px;
    }
    .el-dialog__body {
      padding: 0px !important;
    }
    width: 70%;

    .left {
      width: 100%;
      // max-width: 900px;
      color: rgb(69, 90, 100);
      position: relative;
      .question {
        background-color: #fff;
      }
      .title {
        font-size: 12px;
        background-color: rgb(255, 249, 233);
        padding: 20px;
        margin-bottom: 20px;
      }
      .sumbit-button {
        margin-left: 60px;
        width: 100px;
        height: 36px;
        background-color: rgba(255, 255, 255, 1);
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(199, 0, 10, 1);
        border-radius: 4px;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
        box-shadow: none;
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        color: #c7000a;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
        &:hover {
          background-color: #c7000a;
          color: #fff;
        }
      }
      .last {
        padding: 20px;
        .last-item {
          line-height: 30px;
          color: rgb(69, 90, 100);
          display: flex;
          flex-direction: row;
          span {
            display: block;
            white-space: normal;
            div {
              display: inline;
              span {
                display: inline;
              }
            }
          }
        }
      }
      .backs {
        background-color: rgb(246, 249, 250);
      }
      .tabs {
        padding-left: 20px;
        padding-right: 20px;
        // height: 48px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        color: #a2aabc;

        .tab-right {
          display: flex;
          flex-direction: row;

          .tab-right-item {
            border-right: rgba(238, 238, 238, 1) 1px solid;
            cursor: pointer;
            padding: 0 10px;
            &:hover {
              color: #c7000a;
              i {
                color: #c7000a;
              }
            }
          }
          .tab-right-item:last-child {
            border-right: rgba(238, 238, 238, 1) 0px solid;
          }
        }
        .tab-left {
          display: flex;
          flex-direction: row;
          .answer-true {
            margin-right: 20px;
          }
          .answer-wrong {
            margin-right: 20px;
          }
        }
      }
      .question-answer-result {
        line-height: 20px;
        p {
          display: inline;
        }
        i {
          font-size: 18px;
        }
      }
      .question-answer {
        margin-left: 30px;
        margin-top: 10px;
        display: flex;
        justify-content: flex-start;
        .el-checkbox-group {
          width: 100% !important;
          .el-checkbox {
            margin-right: 30px !important;
            display: flex !important;
            flex-direction: row !important;
            align-items: flex-start !important;
            padding: 10px 10px !important;
            &:hover {
              background: rgb(246, 249, 250);
            }
          }
          label {
            display: block !important;
            // height: 40px !important;
            // line-height: 40px !important;

            .el-radio__input.is-checked .el-radio__inner {
              border-color: rgb(160, 170, 188) !important;
              background: rgb(160, 170, 188) !important;
            }
            .el-checkbox__input.is-checked + .el-checkbox__label {
              color: rgb(69, 90, 100) !important;
            }
            .el-checkbox__inner {
              width: 18px !important;
              height: 18px !important;
            }
            .el-checkbox__inner::after {
              height: 8px !important;
              left: 6px !important;
              top: 2px !important;
            }

            .el-checkbox__input.is-checked .el-checkbox__inner {
              border-color: rgb(160, 170, 188) !important;
              background: rgb(160, 170, 188) !important;
            }
            .el-checkbox__input.is-checked .el-checkbox__inner {
              &:hover {
                border-color: rgb(160, 170, 188) !important;
              }
            }
            .el-checkbox__label {
              font-size: 16px !important;
              color: rgb(69, 90, 100) !important;
            }
          }
        }
        .el-radio-group {
          width: 100% !important;
          .el-radio {
            margin-right: 30px !important;
            padding: 0 10px;
            margin-left: 0px !important;
            &:hover {
              background: rgb(246, 249, 250);
            }
          }
          label {
            display: block !important;
            // height: 40px !important;
            margin-bottom: 10px !important;
            line-height: 40px !important;
            .el-radio__input.is-checked .el-radio__inner {
              border-color: rgb(160, 170, 188) !important;
              background: rgb(160, 170, 188) !important;
            }
            .el-radio__inner {
              width: 18px !important;
              height: 18px !important;
            }
            .el-radio__inner::after {
              width: 7px !important;
              height: 7px !important;
            }
            .el-radio__label {
              font-size: 16px !important;
              color: rgb(69, 90, 100) !important;
            }
          }
        }
      }
      .question-one {
        padding: 20px;
        .tab-right {
          // margin-top: 20px;
          height: 20px;
          .tab-right-false {
            font-size: 13px;
            color: #a2aabc;
            float: right;
          }
          .tab-right-false:hover {
            cursor: pointer;
            color: rgba(199, 0, 10, 1);
          }
          .tab-right-true {
            font-size: 13px;
            color: rgba(199, 0, 10, 1);
            float: right;
          }
          .tab-right-true:hover {
            cursor: pointer;
          }
        }
      }
      .question-name {
        line-height: 24px;
        text-align: left;
        .name {
          font-weight: bold;
        }
      }
    }
  }
  .el-input__inner {
    border-radius: 4px !important;
  }
  .report-bottom {
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .report-bottom-item {
      width: 25%;
      cursor: pointer;
      .bottom-item {
        width: 150px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(238, 238, 238, 1);
        border-radius: 27px;
        color: #455a64;
        &:hover {
          border-color: #c7000a;
          color: #c7000a;
        }
      }
      .bottom-item2 {
        width: 150px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-width: 1px;
        border-style: solid;
        border-color: #c7000a;
        background: #c7000a;
        border-radius: 27px;
        color: #fff;
        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
  .reportTablecss {
    padding: 0 20px;
    .tableclass {
      border-bottom: 0px;
    }
    tr {
      border: 0px !important;
    }
    .gr {
      color: rgba(65, 212, 151, 1);
    }
    .re {
      color: #fc5e5e;
    }
    .progresss {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .text {
        color: #a2aabc;
        line-height: 13px;
        padding: 20px 0;
      }
      .progresss-squ {
        width: 120px;
        height: 120px;
        background-color: rgba(65, 212, 151, 1);
        border-radius: 50%;
        color: #fff;
        font-size: 48px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        span {
          font-size: 14px;
        }
      }
    }
  }

  .dialog-footers {
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-dropdown-menu__item {
    line-height: 54px !important;
    border-bottom: rgba(238, 238, 238, 1) 0px solid !important;
    &:hover {
      color: #c7000a !important;
    }
  }
  .el-switch.is-checked .el-switch__core::after {
    left: 100% !important;
    margin-left: -28px !important;
  }
  .el-switch__core:after {
    content: "" !important;
    position: absolute !important;
    top: 1px !important;
    left: 2px !important;
    border-radius: 100% !important;
    -webkit-transition: all 0.3s !important;
    transition: all 0.3s !important;
    width: 26px !important;
    height: 26px !important;
  }
  .el-switch__core {
    margin: 0 !important;
    position: relative !important;
    width: 60px !important;
    height: 30px !important;
    border: 1px solid #dcdfe6 !important;
    outline: 0 !important;
    border-radius: 15px !important;
    -webkit-box-sizing: border-box !important;
    box-sizing: border-box !important;
    -webkit-transition: border-color 0.3s, background-color 0.3s !important;
    transition: border-color 0.3s, background-color 0.3s !important;
    vertical-align: middle !important;
  }
  .text-size {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .el-popper {
    width: 400px !important;
  }
  .el-button-group {
    // border: #c7000a solid 1px !important;
    // border-radius: 4px!important;
    .res {
      background: #c7000a !important;
      color: #ffffff !important;
    }
    .el-button {
      border: #c7000a solid 1px !important;
      padding: 8px 12px !important;
      &:hover {
        color: #606266;
      }
    }
  }

  .header {
    width: 1200px;
    margin: auto;
    background: #ffffff;
    .title {
      padding: 20px;
      color: #455a64;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border-bottom: rgba(238, 238, 238, 1) 1px solid;
    }
    .text {
      padding: 20px;
      font-size: 24px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fullTruthModelTest/examination.vue